import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

// Define the base URLs for the products and stores endpoints
const PRODUCTS_API_BASE_URL = apiMainUrl + 'Products';
const STORES_API_BASE_URL = apiMainUrl + 'Stores';

/**
 * Fetch products from the API using search, filtering, and sorting parameters.
 *
 * @param {object} params - The query parameters (e.g., { search, brands, categories, subcategories, sortBy, sortAsc }).
 * @param {string} token - The bearer token for API authorization.
 * @returns {Promise} - Axios response or error response.
 */
const getProducts = async (params, token) => {
    try {
        const response = await axios.get(PRODUCTS_API_BASE_URL, {
            params,
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching products:', error);
        return error.response;
    }
};

/**
 * Fetch product from the API using product key.
 *
 * @param {object} productId - The query parameters (e.g., { search, brands, categories, subcategories, sortBy, sortAsc }).
 * @param {string} token - The bearer token for API authorization.
 * @returns {Promise} - Axios response or error response.
 */
const getProductById = async (productId, token) => {
    try {
        const response = await axios.get(`${PRODUCTS_API_BASE_URL}/${productId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching products:', error);
        return error.response;
    }
};

const getStorePerformance = async (productId, token) => {
    try {
        const response = await axios.get(`${PRODUCTS_API_BASE_URL}/${productId}/store-performance`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching products:', error);
        return error.response;
    }
};

const getBrandShare  = async (productId, token) => {
    try {
        const response = await axios.get(`${PRODUCTS_API_BASE_URL}/${productId}/brand-share`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching products:', error);
        return error.response;
    }
};

const getProductTrend  = async (productId, token) => {
    try {
        const response = await axios.get(`${PRODUCTS_API_BASE_URL}/${productId}/product-trend`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching products:', error);
        return error.response;
    }
};

const updateProductImage = async (productId, file, token) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
        const response = await axios.post(
            `${PRODUCTS_API_BASE_URL}/${productId}/edit-image`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        return response;
    } catch (error) {
        console.error('Error updating product image:', error);
        return error.response;
    }
};

/**
 * Fetch stores from the API using search, filtering, and sorting parameters.
 *
 * @param {object} params - The query parameters (e.g., { search, countries, regions, cities, postalCodes, sortBy, sortAsc }).
 * @param {string} token - The bearer token for API authorization.
 * @returns {Promise} - Axios response or error response.
 */
const getStores = async (params, token) => {
    try {
        const response = await axios.get(STORES_API_BASE_URL, {
            params,
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching stores:', error);
        return error.response;
    }
};

/**
 * Fetch product from the API using product key.
 *
 * @param {object} storeId - The query parameters (e.g., { search, brands, categories, subcategories, sortBy, sortAsc }).
 * @param {string} token - The bearer token for API authorization.
 * @returns {Promise} - Axios response or error response.
 */
const getStoreById = async (storeId, token) => {
    try {
        const response = await axios.get(`${STORES_API_BASE_URL}/${storeId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching products:', error);
        return error.response;
    }
};

const updateStoreImage = async (storeId, file, token) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
        const response = await axios.post(
            `${STORES_API_BASE_URL}/${storeId}/edit-image`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        return response;
    } catch (error) {
        console.error('Error updating product image:', error);
        return error.response;
    }
};

const getProductFilterOptions = async (token) => {
    try {
        const response = await axios.get(`${PRODUCTS_API_BASE_URL}/filters`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching product filter options:', error);
        return error.response;
    }
};

const getStoreFilterOptions = async (token) => {
    try {
        const response = await axios.get(`${STORES_API_BASE_URL}/filters`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching store filter options:', error);
        return error.response;
    }
};

export const CatalogDataService = {
    getProducts,
    getStores,
    getProductFilterOptions,
    getStoreFilterOptions,
    getProductById,
    getStoreById,
    updateProductImage,
    updateStoreImage,
    getStorePerformance,
    getBrandShare,
    getProductTrend
};
